import React, { useState, useRef, useEffect } from 'react';
import './DigitalFarming.css';

const DigitalFarming = () => {
  
  return (
    <section className={`md:py-[25px] py-1 md:px-0 px-4 md:pr-20 md:pl-[120px] mb-8  bg-white`}>
      {/* Heading moved outside the box */}
      <div className="md:text-left z-10 relative ">
        <h1 className={`text-black font-bold text-[10px] md:text-[36px] md:-mt-3  tracking-wide`}>
        Smart farming
        </h1>
      </div>
      <div className="relative w-full h-full rounded-[2px] mt-4">
      {/* Full width & height image */}
      <img
        src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759071148/image_2551_1_pcypsg.png"
        alt="Background"
        className="w-full h-full rounded-[4px]"
      />

      {/* Button bottom right */}
      <div className="absolute bottom-4 md:bottom-8 right-4">
        <a
          href="/Register_As_Farm"
          className="md:w-[220px] w-[80px] h-[15px] md:h-[50px] flex items-center justify-center rounded-[2px] md:rounded-[8px] font-bold text-[6px] md:text-[20px] text-white shadow-xl"
          style={{
            background: "linear-gradient(90deg, #FDBB26 25%, #152C24 53%)",
            boxShadow: "0px 4px 10px rgba(0,0,0,0.3)",
          }}
        >
          <span className="flex-1 text-center">Go To</span>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756410811/Expand_right_1_bpdsxb.png"
            alt="arrow"
            className="md:w-[23px] w-[12px] h-[14px] md:h-[21px] mr-1 md:mr-4"
          />
        </a>
      </div>
    </div>

    </section>
  );
};

export default DigitalFarming;